import React from 'react';

interface LineLayoutGridIconProps {
  size?: number;
  color?: string;
}

export const LineLayoutGridIcon: React.FC<LineLayoutGridIconProps> = ({ size = 24, color = '#686868' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
      <mask id="path-1-inside-1_2364_2666" fill="white">
        <path d="M3 4C3 3.44772 3.44772 3 4 3H10C10.5523 3 11 3.44772 11 4V10C11 10.5523 10.5523 11 10 11H4C3.44772 11 3 10.5523 3 10V4Z" />
      </mask>
      <path
        d="M4 3V5H10V3V1H4V3ZM11 4H9V10H11H13V4H11ZM10 11V9H4V11V13H10V11ZM3 10H5V4H3H1V10H3ZM4 11V9C4.55228 9 5 9.44772 5 10H3H1C1 11.6569 2.34315 13 4 13V11ZM11 10H9C9 9.44772 9.44772 9 10 9V11V13C11.6569 13 13 11.6569 13 10H11ZM10 3V5C9.44772 5 9 4.55228 9 4H11H13C13 2.34315 11.6569 1 10 1V3ZM4 3V1C2.34315 1 1 2.34315 1 4H3H5C5 4.55228 4.55228 5 4 5V3Z"
        fill={color}
        mask="url(#path-1-inside-1_2364_2666)"
      />
      <mask id="path-3-inside-2_2364_2666" fill="white">
        <path d="M3 14C3 13.4477 3.44772 13 4 13H10C10.5523 13 11 13.4477 11 14V20C11 20.5523 10.5523 21 10 21H4C3.44772 21 3 20.5523 3 20V14Z" />
      </mask>
      <path
        d="M4 13V15H10V13V11H4V13ZM11 14H9V20H11H13V14H11ZM10 21V19H4V21V23H10V21ZM3 20H5V14H3H1V20H3ZM4 21V19C4.55228 19 5 19.4477 5 20H3H1C1 21.6569 2.34315 23 4 23V21ZM11 20H9C9 19.4477 9.44772 19 10 19V21V23C11.6569 23 13 21.6569 13 20H11ZM10 13V15C9.44772 15 9 14.5523 9 14H11H13C13 12.3431 11.6569 11 10 11V13ZM4 13V11C2.34315 11 1 12.3431 1 14H3H5C5 14.5523 4.55228 15 4 15V13Z"
        fill={color}
        mask="url(#path-3-inside-2_2364_2666)"
      />
      <mask id="path-5-inside-3_2364_2666" fill="white">
        <path d="M13 4C13 3.44772 13.4477 3 14 3H20C20.5523 3 21 3.44772 21 4V10C21 10.5523 20.5523 11 20 11H14C13.4477 11 13 10.5523 13 10V4Z" />
      </mask>
      <path
        d="M14 3V5H20V3V1H14V3ZM21 4H19V10H21H23V4H21ZM20 11V9H14V11V13H20V11ZM13 10H15V4H13H11V10H13ZM14 11V9C14.5523 9 15 9.44772 15 10H13H11C11 11.6569 12.3431 13 14 13V11ZM21 10H19C19 9.44772 19.4477 9 20 9V11V13C21.6569 13 23 11.6569 23 10H21ZM20 3V5C19.4477 5 19 4.55228 19 4H21H23C23 2.34315 21.6569 1 20 1V3ZM14 3V1C12.3431 1 11 2.34315 11 4H13H15C15 4.55228 14.5523 5 14 5V3Z"
        fill={color}
        mask="url(#path-5-inside-3_2364_2666)"
      />
      <mask id="path-7-inside-4_2364_2666" fill="white">
        <path d="M13 14C13 13.4477 13.4477 13 14 13H20C20.5523 13 21 13.4477 21 14V20C21 20.5523 20.5523 21 20 21H14C13.4477 21 13 20.5523 13 20V14Z" />
      </mask>
      <path
        d="M14 13V15H20V13V11H14V13ZM21 14H19V20H21H23V14H21ZM20 21V19H14V21V23H20V21ZM13 20H15V14H13H11V20H13ZM14 21V19C14.5523 19 15 19.4477 15 20H13H11C11 21.6569 12.3431 23 14 23V21ZM21 20H19C19 19.4477 19.4477 19 20 19V21V23C21.6569 23 23 21.6569 23 20H21ZM20 13V15C19.4477 15 19 14.5523 19 14H21H23C23 12.3431 21.6569 11 20 11V13ZM14 13V11C12.3431 11 11 12.3431 11 14H13H15C15 14.5523 14.5523 15 14 15V13Z"
        fill={color}
        mask="url(#path-7-inside-4_2364_2666)"
      />
    </svg>
  );
};
